/* =====================================================================
   PIKOC — Fontaine offerte pour tout abonnement éco-recharge 5L  (v2)
   ---------------------------------------------------------------------
   Principe : on ne re-render JAMAIS le drawer nous-mêmes.

   AJOUT   → on intercepte la requête /cart/add du thème AVANT envoi :
             si l'item ajouté est une 5L en abonnement (selling_plan)
             et que la fontaine n'est pas déjà au panier, on transforme
             la requête en ajout multi-items (recharge + fontaine).
             Shopify renvoie au thème des sections déjà complètes →
             rendu natif Impact, une seule fois, progress bar intacte.

   RETRAIT → on intercepte /cart/change|update|clear AVANT envoi :
             si l'opération fait disparaître le dernier abonnement 5L,
             on retire d'abord la fontaine (appel interne silencieux),
             puis on laisse passer la requête du thème, dont le rendu
             arrivera donc déjà sans la fontaine.
             (Les requêtes par numéro de ligne sont converties en clé
             de ligne pour que la suppression préalable ne décale rien.)

   ⚙️ CONFIG : mettre à jour les IDs ci-dessous si les variantes changent.
   ===================================================================== */
(function () {
  'use strict';

  /* ----------------------- CONFIG ----------------------- */

  // Variante du produit cadeau "Fontaine à lessive - 4L offerte" (0€)
  var GIFT_VARIANT_ID = 57888532529487;

  // Variantes éco-recharges 5L qui déclenchent le cadeau (en abonnement)
  var QUALIFYING_VARIANT_IDS = [
    44585513288000, // Éclat d'Iris 5L
    48798542528847, // Ambre Beige 5L
    44585512993088, // Bois Mythique 5L
    44585513091392  // Oranger en Fleurs 5L
  ];

  var GIFT_PROPERTY = '_fontaine_offerte';
  var INTERNAL_HEADER = 'X-Pikoc-Gift';

  /* --------------------- HELPERS ------------------------ */

  var _fetch = window.fetch.bind(window);

  function internalHeaders(extra) {
    var h = extra || {};
    h[INTERNAL_HEADER] = '1';
    return h;
  }

  function isInternal(init) {
    if (!init || !init.headers) return false;
    var h = init.headers;
    if (typeof h.get === 'function') return !!h.get(INTERNAL_HEADER);
    return !!h[INTERNAL_HEADER];
  }

  function getCart() {
    return _fetch('/cart.js', { headers: internalHeaders() })
      .then(function (r) { return r.json(); });
  }

  function findGift(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].id === GIFT_VARIANT_ID) return cart.items[i];
    }
    return null;
  }

  function itemQualifies(variantId, hasSellingPlan) {
    return hasSellingPlan && QUALIFYING_VARIANT_IDS.indexOf(Number(variantId)) !== -1;
  }

  function cartQualifies(cart) {
    return cart.items.some(function (it) {
      return it.selling_plan_allocation &&
             QUALIFYING_VARIANT_IDS.indexOf(it.id) !== -1;
    });
  }

  function removeGiftSilently() {
    return _fetch('/cart/change.js', {
      method: 'POST',
      headers: internalHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ id: String(GIFT_VARIANT_ID), quantity: 0 })
    }).catch(function () {});
  }

  /* ------- Lecture du body d'une requête (3 formats possibles) ------- */

  function readBody(init, input) {
    // Renvoie { kind: 'json'|'form'|'params'|null, data }
    var b = init && init.body;
    if (!b && input instanceof Request) {
      // corps porté par l'objet Request : on le clone pour le lire
      return input.clone().text().then(function (txt) {
        return parseText(txt, input.headers.get('Content-Type') || '');
      });
    }
    if (typeof b === 'string') {
      var ct = '';
      if (init.headers) {
        ct = (typeof init.headers.get === 'function')
          ? (init.headers.get('Content-Type') || '')
          : (init.headers['Content-Type'] || init.headers['content-type'] || '');
      }
      return Promise.resolve(parseText(b, ct));
    }
    if (typeof FormData !== 'undefined' && b instanceof FormData) {
      return Promise.resolve({ kind: 'form', data: b });
    }
    if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) {
      return Promise.resolve({ kind: 'params', data: b });
    }
    return Promise.resolve({ kind: null, data: null });
  }

  function parseText(txt, contentType) {
    if (/json/i.test(contentType)) {
      try { return { kind: 'json', data: JSON.parse(txt) }; } catch (e) {}
    }
    try { return { kind: 'json', data: JSON.parse(txt) }; } catch (e) {}
    return { kind: 'params', data: new URLSearchParams(txt) };
  }

  function getField(parsed, name) {
    if (!parsed || !parsed.data) return null;
    if (parsed.kind === 'json') return parsed.data[name];
    return parsed.data.get(name); // form & params
  }

  /* ------------------ AJOUT : fusion multi-items ------------------ */

  function extractAddItems(parsed) {
    // Normalise les items de la requête add en tableau d'objets JSON
    if (parsed.kind === 'json') {
      if (Array.isArray(parsed.data.items)) return parsed.data.items.slice();
      if (parsed.data.id != null) {
        var single = { id: Number(parsed.data.id), quantity: Number(parsed.data.quantity || 1) };
        if (parsed.data.selling_plan) single.selling_plan = Number(parsed.data.selling_plan);
        if (parsed.data.properties) single.properties = parsed.data.properties;
        return [single];
      }
      return [];
    }
    // form / params : format id=...&quantity=...&selling_plan=...&properties[x]=y
    var d = parsed.data;
    var id = d.get('id');
    if (id == null) return [];
    var item = { id: Number(id), quantity: Number(d.get('quantity') || 1) };
    var sp = d.get('selling_plan');
    if (sp) item.selling_plan = Number(sp);
    var props = {};
    var hasProps = false;
    d.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m) { props[m[1]] = value; hasProps = true; }
    });
    if (hasProps) item.properties = props;
    return [item];
  }

  function buildMergedAddInit(parsed, items, originalInit) {
    var giftProps = {};
    giftProps[GIFT_PROPERTY] = 'true';
    items.push({ id: GIFT_VARIANT_ID, quantity: 1, properties: giftProps });

    var payload = { items: items };
    // Préserver le Section Rendering du thème (clé du rendu natif sans flicker)
    var sections = getField(parsed, 'sections');
    var sectionsUrl = getField(parsed, 'sections_url');
    if (sections) payload.sections = sections;
    if (sectionsUrl) payload.sections_url = sectionsUrl;

    var init = Object.assign({}, originalInit);
    init.method = 'POST';
    init.body = JSON.stringify(payload);

    // Normaliser les headers en objet simple + forcer JSON
    var headers = {};
    var oh = originalInit && originalInit.headers;
    if (oh) {
      if (typeof oh.forEach === 'function') {
        oh.forEach(function (v, k) { headers[k] = v; });
      } else {
        Object.keys(oh).forEach(function (k) { headers[k] = oh[k]; });
      }
    }
    headers['Content-Type'] = 'application/json';
    init.headers = headers;
    return init;
  }

  /* --------- RETRAIT : simulation de l'état après l'opération --------- */

  function simulateAfter(cart, url, parsed) {
    // Renvoie { qualifies, targetsGift } : état du panier après l'opération
    var items = cart.items.map(function (it) {
      return {
        id: it.id,
        key: it.key,
        quantity: it.quantity,
        subscribed: !!it.selling_plan_allocation
      };
    });
    var targetsGift = false;

    function applyQty(predicate, qty) {
      items.forEach(function (it) {
        if (predicate(it)) {
          if (it.id === GIFT_VARIANT_ID) targetsGift = true;
          it.quantity = qty;
        }
      });
    }

    if (/\/cart\/clear/.test(url)) {
      items.forEach(function (it) { it.quantity = 0; });
    } else if (/\/cart\/change/.test(url)) {
      var qty = Number(getField(parsed, 'quantity'));
      if (isNaN(qty)) return null; // changement de propriétés only → ne rien décider
      var line = getField(parsed, 'line');
      var idField = getField(parsed, 'id');
      if (line != null && line !== '') {
        var idx = Number(line) - 1;
        if (items[idx]) {
          if (items[idx].id === GIFT_VARIANT_ID) targetsGift = true;
          items[idx].quantity = qty;
        }
      } else if (idField != null) {
        var idStr = String(idField);
        applyQty(function (it) {
          return it.key === idStr || String(it.id) === idStr;
        }, qty);
      }
    } else if (/\/cart\/update/.test(url)) {
      var updates = (parsed.kind === 'json') ? parsed.data.updates : null;
      if (!updates) {
        // format form: updates[KEY]=qty
        updates = {};
        parsed.data.forEach(function (value, keyName) {
          var m = keyName.match(/^updates\[(.+)\]$/);
          if (m) updates[m[1]] = value;
        });
      }
      if (Array.isArray(updates)) {
        updates.forEach(function (q, i) {
          if (items[i]) {
            if (items[i].id === GIFT_VARIANT_ID) targetsGift = true;
            items[i].quantity = Number(q);
          }
        });
      } else if (updates && typeof updates === 'object') {
        Object.keys(updates).forEach(function (k) {
          applyQty(function (it) {
            return it.key === k || String(it.id) === String(k);
          }, Number(updates[k]));
        });
      }
    }

    var qualifies = items.some(function (it) {
      return it.quantity > 0 && it.subscribed &&
             QUALIFYING_VARIANT_IDS.indexOf(it.id) !== -1;
    });
    return { qualifies: qualifies, targetsGift: targetsGift };
  }

  function rewriteLineToKey(cart, parsed, init) {
    // Convertit {line: n} en {id: lineKey} pour que la suppression préalable
    // de la fontaine ne décale pas la cible de la requête du thème.
    var line = getField(parsed, 'line');
    if (line == null || line === '') return init;
    var idx = Number(line) - 1;
    var item = cart.items[idx];
    if (!item) return init;

    if (parsed.kind === 'json') {
      var data = Object.assign({}, parsed.data);
      delete data.line;
      data.id = item.key;
      var ni = Object.assign({}, init);
      ni.body = JSON.stringify(data);
      return ni;
    }
    // form / params
    var d = parsed.data;
    d.delete('line');
    d.set('id', item.key);
    var ni2 = Object.assign({}, init);
    ni2.body = (parsed.kind === 'form') ? d : d.toString();
    return ni2;
  }

  /* ---------------------- INTERCEPTEUR ---------------------- */

  window.fetch = function (input, init) {
    init = init || {};
    var url = (typeof input === 'string') ? input : (input && input.url) || '';

    if (isInternal(init)) return _fetch(input, init);

    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    var isMutation = /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url);

    if (!isAdd && !isMutation) return _fetch(input, init);

    /* ---------- AJOUT ---------- */
    if (isAdd) {
      return readBody(init, input).then(function (parsed) {
        if (!parsed || !parsed.kind) return _fetch(input, init);

        var items = extractAddItems(parsed);
        var hasQualifying = items.some(function (it) {
          return itemQualifies(it.id, it.selling_plan != null);
        });
        if (!hasQualifying) return _fetch(input, init);

        return getCart().then(function (cart) {
          if (findGift(cart)) return _fetch(input, init); // déjà offerte
          var mergedInit = buildMergedAddInit(parsed, items, init);
          var target = (typeof input === 'string') ? input : url;
          return _fetch(target, mergedInit);
        }).catch(function () {
          return _fetch(input, init); // en cas de pépin, ne jamais bloquer l'achat
        });
      });
    }

    /* ---------- RETRAIT ---------- */
    return readBody(init, input).then(function (parsed) {
      if (!parsed) return _fetch(input, init);

      return getCart().then(function (cart) {
        var gift = findGift(cart);
        if (!gift) return _fetch(input, init); // pas de fontaine → rien à gérer

        var sim = simulateAfter(cart, url, parsed);
        if (!sim || sim.targetsGift || sim.qualifies) {
          // soit on ne sait pas décider, soit le client touche lui-même
          // à la ligne cadeau, soit l'offre reste valable → laisser passer
          return _fetch(input, init);
        }

        // Plus aucun abonnement 5L après l'opération :
        // retirer la fontaine d'abord, puis exécuter la requête du thème
        // (réécrite en clé de ligne pour éviter tout décalage d'index).
        var safeInit = rewriteLineToKey(cart, parsed, init);
        var target = (typeof input === 'string') ? input : url;
        return removeGiftSilently().then(function () {
          return _fetch(target, safeInit);
        });
      }).catch(function () {
        return _fetch(input, init);
      });
    });
  };
})();